'use strict';
/* ============================================
   JM Locale Selectors — Search filtering
   Adds search/filter to existing disclosure
   dropdowns in country-switcher & language-switcher.
   Jeans Manufaktur · jm-2.1.0
   ============================================ */

(function () {
  var observedLists = new WeakSet();

  /* Search filtering inside disclosure lists (delegated) */
  document.addEventListener('input', function (e) {
    if (!e.target.classList.contains('jm-locale-search')) return;
    var panel = e.target.closest('.disclosure__list');
    if (!panel) return;
    var q = e.target.value.toLowerCase().trim();
    var items = panel.querySelectorAll('.disclosure__item');
    items.forEach(function (item) {
      var text = (item.getAttribute('data-label') || item.textContent).toLowerCase();
      item.style.display = (q !== '' && text.indexOf(q) === -1) ? 'none' : '';
    });
  });

  /* Prevent focusout from closing the disclosure when clicking the search input */
  document.addEventListener('mousedown', function (e) {
    if (e.target.classList.contains('jm-locale-search')) {
      e.stopPropagation();
    }
  }, true);

  function resetDisclosureList(el) {
    var input = el.querySelector('.jm-locale-search');
    if (input && input.value) {
      input.value = '';
      el.querySelectorAll('.disclosure__item').forEach(function (item) {
        item.style.display = '';
      });
    }
  }

  /* Clear search when disclosure closes */
  var observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (m) {
      if (m.type === 'attributes' && m.attributeName === 'class') {
        var el = m.target;
        if (el.classList.contains('disclosure__list') && !el.classList.contains('open') && el.classList.contains('invisible')) {
          resetDisclosureList(el);
        }
      }
    });
  });

  function observeList(list) {
    if (observedLists.has(list)) return;
    observedLists.add(list);
    observer.observe(list, { attributes: true, attributeFilter: ['class'] });
  }

  function observeDisclosureLists(root) {
    if (!root) return;
    if (root.matches && root.matches('.disclosure__list')) {
      observeList(root);
    }
    if (root.querySelectorAll) {
      root.querySelectorAll('.disclosure__list').forEach(observeList);
    }
  }

  observeDisclosureLists(document);

  var domObserver = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(function (node) {
        if (node.nodeType === 1) {
          observeDisclosureLists(node);
        }
      });
    });
  });

  domObserver.observe(document.documentElement, {
    childList: true,
    subtree: true
  });
})();
